import React from 'react';
import { Row, Col, Icon } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faDotCircle } from '@fortawesome/free-regular-svg-icons';
import { formatMoneyAmount } from '../../utils/formatUtils';
import Radio from 'antd/es/radio';

const isOdd = (number) => {
  const value = number % 2;
  if (value === 0) {
    return false;
  } else {
    return true;
  }
};

const convertAndFormatAmount = (amountString) => {
  const amount = formatMoneyAmount(parseFloat(amountString));
  if (amount === '$NaN') {
    return '$0.00';
  }
  return amount;
};

const Table = ({ tableData, labels, onTableRowExpand, selectedRowKeys }) => {
  const Label = ({ dataIndex }) => {
    const label = labels.find((label) => label.dataIndex === dataIndex);
    return <p>{label.title}</p>;
  };

  const determineBackgroundColor = (payPlanCd, currentIndex) => {
    if (selectedRowKeys === payPlanCd) {
      return '#e8f9f7';
    } else if (isOdd(currentIndex)) {
      return '#f8f9fa';
    } else {
      return '';
    }
  };



  return (
    <div>
      {tableData.map((row, index) => {
        return (
          <div
            className="mouse-hover-no-color"
            onClick={() => {
              onTableRowExpand(true, row);
            }}
            style={{
              ...styles.column,
              backgroundColor: determineBackgroundColor(row.payPlanCd, index),
            }}
          >
            <div style={styles.buttonColumn}>
              <div style={{ width: '45px' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Radio
                    checked = {selectedRowKeys === row.payPlanCd}
                  />
                </div>
              </div>
            </div>
            <div style={{ flex: 9, flexDirection: 'column' }}>
              <div
                style={{ ...styles.rowContainer, justifyContent: 'flex-start' }}
              >
                <p>{row.name}</p>
              </div>

              <div style={styles.rowContainer}>
                <Label dataIndex={'downPaymentAmt'} />
                <p style={styles.bold}>
                  {convertAndFormatAmount(row.downPaymentAmt)}
                </p>
              </div>

              <div style={styles.rowContainer}>
                <Label dataIndex={'installmentAmt'} />
                <p style={styles.bold}>
                  {convertAndFormatAmount(row.installmentAmt)}
                </p>
              </div>

              <div style={styles.rowContainer}>
                <Label dataIndex={'installmentFeeAmt'} />
                <p style={styles.bold}>
                  {convertAndFormatAmount(row.installmentFeeAmt)}
                </p>
              </div>

              <div style={styles.rowContainer}>
                <Label dataIndex={'totalAmt'} />
                <p style={styles.bold}>
                  {convertAndFormatAmount(row.totalAmt)}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export const PaymentMobileTable = ({
  allPlans,
  titles,
  columns,
  onTableRowExpand,
  selectedRowKeys,
}) => {
  if (!allPlans) return null;
  return (
    <div>
      {allPlans.map((rowData, index) => {
        const title = titles[index];

        return (
          <div style={{ marginTop: '16px' }}>
            <h3>{title}</h3>
            <Table
              onTableRowExpand={onTableRowExpand}
              selectedRowKeys={selectedRowKeys}
              tableData={rowData}
              key={index}
              labels={columns}
            />
          </div>
        );
      })}
    </div>
  );
};

const styles = {
  bold: {
    fontWeight: 'bold',
  },
  buttonColumn: {
    flex: 1,
    marginRight: '8px',
  },
  column: {
    display: 'flex',
    flexDirection: 'row',
    padding: '8px 16px',
  },
  infoColumn: {
    flex: 9,
    flexDirection: 'column',
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
};
